// extracted by mini-css-extract-plugin
export default {"formContainer":"edit-user_formContainer__2xwNs"};